import { takeEvery, put, all } from 'redux-saga/effects';

import * as types from '../actions/password-recovery/types';
import * as actions from '../actions/password-recovery';

import httpStatusCodes from '../constants/http-status-codes';

import apiFetcher from '../tools/api-fetcher';
import handleError from '../tools/error-helper';

function* sendRecoveryRequest({ email }) {
  yield put(actions.setForgotPasswordLoading(true));
  yield put(actions.setRecoveryRequestFailedReason(undefined));

  try {
    yield apiFetcher.post(`password-recovery-requests`, { email });
    yield put(actions.setRecoveryRequestHasBeenSentToEmail(email));
  } catch (exception) {
    switch (exception.response && exception.response.status) {
      case httpStatusCodes.NotFound:
        yield put(
          actions.setRecoveryRequestFailedReason(exception.response.statusText)
        );
        break;
      case httpStatusCodes.BadRequest:
        yield put(
          actions.setRecoveryRequestFailedReason(exception.response.statusText)
        );
        break;
      default:
        handleError(exception);
        break;
    }
  }

  yield put(actions.setForgotPasswordLoading(false));
}

function* validateResetPasswordCode({ code }) {
  yield put(actions.setResetPasswordLoading(true));

  try {
    yield apiFetcher.head(`password-recovery-requests/${code}`);
  } catch (exception) {
    yield handleResetPasswordException(exception);
  }

  yield put(actions.setResetPasswordLoading(false));
}

function* resetPasswordByCode({ code, password }) {
  yield put(actions.setResetPasswordLoading(true));

  try {
    yield apiFetcher.put(`password-recovery-requests/${code}`, { password });
    yield put(actions.setPasswordSuccessfullyChanged(true));
  } catch (exception) {
    yield handleResetPasswordException(exception);
  }

  yield put(actions.setResetPasswordLoading(false));
}

function* handleResetPasswordException(exception) {
  switch (exception.response && exception.response.status) {
    case httpStatusCodes.NotFound: {
      yield put(actions.setCodeIsNotFound(true));
      break;
    }
    case httpStatusCodes.Gone: {
      yield put(actions.setCodeIsExpiredOrUsed(true));
      break;
    }
    default: {
      handleError(exception);
      break;
    }
  }
}

export default function* passwordRecoverySaga() {
  yield all([
    takeEvery(
      types.PASSWORD_RECOVERY_SEND_RECOVERY_REQUEST,
      sendRecoveryRequest
    ),
    takeEvery(types.PASSWORD_RECOVERY_SEND_RESET_EMAIL, sendRecoveryRequest),
    takeEvery(
      types.PASSWORD_RECOVERY_VALIDATE_RESET_PASSWORD_CODE,
      validateResetPasswordCode
    ),
    takeEvery(types.PASSWORD_RECOVERY_RESET_PASSWORD, resetPasswordByCode)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/password-recovery.js